import { Modal } from "antd";
import React, { useState,useRef } from "react";
import RoleEditForm from "./roleEditForm";
import RoleSearchForm from "./roleSearchForm";

import { deleteJob, editJob, getJobList } from "../../../api/departmentJob";

export default function ModuleRole() {
  const [beanCount, setBeanCount] = useState("");
  const [beanType, setBeanType] = useState();
  const [data, setData] = useState(originData);
  const [editingRecord, setEditingRecord] = useState(null);

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  
  const [inputSelect, setinputSelect] = useState(null);

  const deleteModalHandleOk = async () => {
    setIsDeleteModalOpen(false);
    //删除
    console.log(editingRecord);
    await deleteJob(editingRecord.job_id);
    //重新加载
    // let input = { page_no: 1, page_size: 10 };
    let r = await getJobList(inputSelect);
    console.log(r);
    setData(r.data.list);
  };
  const deleteModalHandleCancel = () => {
    setIsDeleteModalOpen(false);
  };

  const handleDelete = (record,input) => {
    //console.log('handleDelete: ', record);
    setEditingRecord(record);
    setinputSelect(input);
    setIsDeleteModalOpen(true);
  };

  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  const editModalHandleOk = async (record) => {
    console.log("editModalHandleOk: ", record);
    setIsEditModalOpen(false);
    await editJob(record);
  };
  const editModalHandleCancel = () => {
    setIsEditModalOpen(false);
  };

  const handleEdit = (record) => {
    console.log("handleEdit: ", record);

    // let str = record.smartBeans;
    // console.log('handleEdit 1: ', str);
    // const index = str.indexOf("/");
    // console.log('handleEdit 2: ', str.substring(0, index));
    // console.log('handleEdit 3: ', str.substring(index + 1));
    // setBeanCount(str.substring(0, index));
    // if ("月" == str.substring(index + 1)) {
    //   setBeanType(1);
    // }
    // else {
    //   setBeanType(0);
    // }
    setEditingRecord(record);
    setIsEditModalOpen(true);
  };

  return (
    <div width="100%">
      <RoleSearchForm
        data={data}
        setData={setData}
        handleDelete={handleDelete}
        handleEdit={handleEdit}
      />
      {editingRecord && isEditModalOpen && (
        <RoleEditForm
          editdata={editingRecord}
          isModalVisible={isEditModalOpen}
          editModalHandleOk={editModalHandleOk}
          editModalHandleCancel={editModalHandleCancel}
          setData={setData}
        ></RoleEditForm>
      )}
      {editingRecord && (
        <Modal
          title="确认信息"
          key={editingRecord.job_id}
          open={isDeleteModalOpen}
          onOk={deleteModalHandleOk}
          onCancel={deleteModalHandleCancel}
          cancelText="取消"
          okText="确定"
        >
          <p>
            确定要删除 {editingRecord.main_depart_name}-
            {editingRecord.second_depart_name}板块中的{editingRecord.job_name}
            角色？
          </p>
        </Modal>
      )}
    </div>
  );
}

const originData = [
  // {
  //   bean_amount: 0,
  //   ctime: "2024-06-22 09:38:00",
  //   department_id: 11,
  //   description: "岗位说明",
  //   job_id: 1,
  //   job_name: "向导",
  //   level: 0,
  //   main_depart_name: "新手村",
  //   payment_frequency: 0,
  //   second_depart_name: "书香村"
  // }
];
